export interface IOnSubformAjaxEditPubObj {
  mainFieldSubFormHolder: IjQueryElm;
  subFormFieldId: string;
  subFormId: string;
}

export type IOnSubformAjaxEdit = (e: JQuery.ClickEvent, pubObj: IOnSubformAjaxEditPubObj) => any;

export function onSubformAjaxEdit(e: JQuery.ClickEvent, pubObj: IOnSubformAjaxEditPubObj) {
  const { mainFieldSubFormHolder } = pubObj;
  const $field: IjQueryElm = mainFieldSubFormHolder.parent('.field');

  window.DexeroCoreApp.resolveFieldAction($field);
}
